export default __webpack_public_path__ + "static/media/collection.18fbf360.svg";